import { useEffect, useRef } from 'react';
import { getOidcManager } from '../../service/auth/oidc';

/** The hidden Keycloak iframe returns here when renewing an OIDC session. */
export default function OidcSilentRenew() {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    void getOidcManager().signinSilentCallback();
  }, []);

  return null;
}
